import { createFileRoute } from '@tanstack/react-router'

import { MastersPage } from '@/pages/masters-page'

export const Route = createFileRoute('/_dashboard-layout/masters')({
    component: MastersPage,
})
